module.exports = __webpack_public_path__ + "static/media/Mantenimiento.9219476e.png";